import axios from '../axios';
import store from '../../store';

class Site{
    constructor() {
        this.site_list = '/template/site_configuration/list';
        this.valid_site_code = '/template/valid_site_code/list';
        this.creat_valid_site_code = '/template/valid_site_code/';
        this.del_valid_site_code = '/template/valid_site_code/:id/';
    }
    getSiteList(params = {}) {
        if(!params.company_code) params.company_code = store.state.common.company_code;
        return axios(this.site_list, { method: 'get', params });
    }
    getValidSiteCode(params) {
        return axios(this.valid_site_code, { method: 'get', params });
    }
    CreateValidSiteCode(params) {
        return axios(this.creat_valid_site_code, { method: 'post', params });
    }
    DeleteValidSiteCode(params) {
        return axios(this.del_valid_site_code, { method: 'delete', params });
    }
};
export default new Site();




// WEBPACK FOOTER //
// ./src/api/modules/site.js